<div class="info_card__header">
  @if (infoDate) {
    <div class="caption"
      >{{infoDate | date:dateTimeStandard}} {{ "STRINGS.TIME" | translate}}
      @if (federalStates && federalStates.length) {
        –
        <app-federal-state [ids]="federalStates"></app-federal-state>
      }
    </div>
  } @else {
    <div class="caption">{{ "STRINGS.DRAFT" | translate}}</div>
  }


  <!-- in case of no date, show a no date info -->
  @if (new) {
    <div class="caption-flag">neu</div>
  }
  @if (declined) {
    <app-svg-icon
      class="icon"
      [src]="'icons/24/error.svg'"
      [svgStyle]="{ 'width.px': '24', 'height.px': '24' }"
    ></app-svg-icon>
  }
</div>
<div class="info_card__content">
  <div class="card-title">{{title}}</div>
  <app-svg-icon
    class="icon"
    [src]="'icons/24/arrow-right.svg'"
    [svgStyle]="{ 'width.px': '24', 'height.px': '24' }"
  ></app-svg-icon>
</div>
